import React from 'react';
import {SESSION_USER,APP_DATE_AND_TIME_FORAMT,DATE_FORAMT,TIME_FORMAT,BLANK_SPACE,SSO_PARAMS} from '../../constants';
import {getScheduleById,insertOrUpdateSchedule,getAllScheduleEvent} from '../../util/APIUtils';
import moment from 'moment';
import $ from 'jquery';
import 'jquery-validation';
import 'jquery-ui-dist/jquery-ui';
import 'jquery-ui-dist/jquery-ui.css';
import 'fullcalendar-scheduler';
import 'bootstrap';
import 'fullcalendar/dist/fullcalendar.min.css';

import 'fullcalendar-scheduler/dist/scheduler.min.css';
import 'timepicker';
import 'timepicker/dist/jquery.timepicker.css'
import GoogleMapForm from './../schedule/GoogleMapForm';
import JobScheduleForm from './../schedule/JobScheduleForm';

class LocationCalendar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            resources:[],
            loading: true,
            modalShow: false,
            selectedSkill:[],
            optionPeopleList: '',
            messageText:'',
            showMessage:false
        };

     this.handlePeopleChange = this.handlePeopleChange.bind(this);
     this.handleRouteChange = this.handleRouteChange.bind(this);
     this.handleJobChange = this.handleJobChange.bind(this);
     this.handleEquipmentChange = this.handleEquipmentChange.bind(this);
     this.handleTeamChange = this.handleTeamChange.bind(this);
  this.handleLocationChange = this.handleLocationChange.bind(this);

     this.updateCalendarEvents = this.updateCalendarEvents.bind(this);
 //    console.log(this.props);
        
    }


    componentDidMount() {
    let $this = this;
    var defaultEventDuration='02:00';
    var workingfromtime='08:00';
    var workingtotime='18:00';
    let user = JSON.parse(localStorage.getItem(SESSION_USER));
   // console.log(user);
    if(user.setting){
         defaultEventDuration= user.setting.defaultEventDuration;
         workingfromtime= user.setting.fromtime;
         workingtotime= user.setting.totime;
    }
    var resourcesObject=this.props.resources;
    var nowtime=this.props.nowdatetime;

//----------------------------------Start Modal Confirm funcation--------------------------------
     var modalConfirm = function(callback){
        $("#saveevent").off('click').click(function () {
          var val =$('#jobscheduleform').valid();
          if(val){
              let user = JSON.parse(localStorage.getItem(SESSION_USER));
              var fields={};
              fields["userId"] = user.id;
              fields['title']=$("#title").val();
              fields['priority']=$("#priority").val();
              fields['description']=$("#description").val();
              fields['address']=$("#address").val();
              fields['teamId']=$("#team").val();
              fields['locationId']=$("#location").val();
              fields['equipmentId']=$("#equipment").val();
              fields['estimatedHours']=$("#estimatedHours").val();


              

              var selectedPeoples = $('#selectedPeoples').val();
                selectedPeoples = (selectedPeoples !== '') ? JSON.parse(selectedPeoples) : [];
             // selectedPeoples = JSON.parse(selectedPeoples);
              //console.log('selectedPeoples', selectedPeoples);

              fields['peopleId']=selectedPeoples.value;
              fields['fromdate']=$("#fromdate").val();
              fields['fromtime']=$("#fromtime").val();
              fields['todate']=$("#todate").val();
              fields['totime']=$("#totime").val();
              fields['type']=1;// 0 means unschedule //1 means schedule

              fields['status']=$("#status").val();
              fields['moduleId']=$("#moduleId").val();
       
              fields['fieldServiceNumber']=$("#fieldServiceNumber").val();
              fields['fieldServiceZohoId']=$("#fieldServiceZohoId").val();
              fields['zohoAppointmentId']=$("#zohoAppointmentId").val();
              
              fields['id']=$("#id").val();

              var selectedSkill = $('#selectedSkill').val();
              if(selectedSkill){
            	  selectedSkill = JSON.parse(selectedSkill);

                  var skillarray=[];
                  if(selectedSkill){
                    for(var k in selectedSkill){
                        var s=selectedSkill[k];
                        skillarray.push(s.value);
                    }
                  }
                  
                 // skillarray.push(selectedSkill[0].value);
                  fields['skillId']=skillarray;
                 // console.log(fields);
              }
              
              

              //return false;
              insertOrUpdateSchedule(fields)
	           .then(response => {   
                  if(!response.success){//if its false so validation error server side
                     // alert(response.message)
                      $this.setState({showMessage:true,messageText:response.message});
                      return false;
                   }else{
                      $this.setState({showMessage:false,messageText:''});
                   }
			       //    var eventss=calendarObject.getEventById(1);
			           var eventFcId= localStorage.getItem('eventFcId');
                   //console.log("eventFcId----");
                 //console.log(eventFcId);
                 if(eventFcId){
                     localStorage.removeItem('eventFcId');
                
                     var eventObj = $("#calendar").fullCalendar('clientEvents',eventFcId)[0];
                     eventObj.title=$("#title").val();

                     var startAsString=$("#fromdate").val()+BLANK_SPACE+$("#fromtime").val();
                     var fromDateObject= moment(startAsString,APP_DATE_AND_TIME_FORAMT);
                     var endAsString=$("#todate").val()+BLANK_SPACE+$("#totime").val();
                     var endDateObject= moment(endAsString,APP_DATE_AND_TIME_FORAMT);
                     
                     eventObj.resourceId=$("#location").val();
                     eventObj.start=fromDateObject;
                     eventObj.end=endDateObject;

                     //console.log(resourcesObject);

                    $('#calendar').fullCalendar('updateEvent',eventObj);


                 }else{

                    var newEvent = new Object();
                    newEvent.title = $("#title").val();
                    
                    
                     var startAsString=$("#fromdate").val()+BLANK_SPACE+$("#fromtime").val();
                     var fromDateObject= moment(startAsString,APP_DATE_AND_TIME_FORAMT);
                     var endAsString=$("#todate").val()+BLANK_SPACE+$("#totime").val();
                     var endDateObject= moment(endAsString,APP_DATE_AND_TIME_FORAMT);
                     
                     newEvent.resourceId=$("#location").val();
                     newEvent.start=fromDateObject;
                     newEvent.end=endDateObject;
                     newEvent.id=response.id;



                    $('#calendar').fullCalendar('renderEvent', newEvent);


                 }
                

			          callback(true);
		            $("#add-new-event").modal('hide');
		            document.getElementById("jobscheduleform").reset();
	          }).catch(error => {             
	                    alert('error111');
	          })


             

          }
          
        });


        $("#closeevent").off('click').click(function () {
              callback(false);
              $("#add-new-event").modal('hide');
              document.getElementById("jobscheduleform").reset();

            });
      };
//----------------------------------End Modal Confirm funcation--------------------------------
    
      function showpopup(externalEventObject,eventId){


     //  $('#add-new-event').modal('show');
       $('#add-new-event').modal({
			      backdrop: 'static',
			      keyboard: false
			    })

       var result= modalConfirm(function(confirm){
        if(confirm){
          externalEventObject.remove();
          return false;
        }else{
          var ids=[eventId];
          $('#calendar').fullCalendar('removeEvents',ids);


          //console.log('No');
          return false;

        }
      });
       return false;


     }

      function showpopup2(eventId){
       $('#add-new-event').modal({
            backdrop: 'static',
            keyboard: false
          })

       var result= modalConfirm(function(confirm){
        if(confirm){
          return false;
        }else{ 
          return false;

        }
      });
       return false;


     }
     var calendarview=this.props.calendarview;
    //alert(nowtime);
    $('#calendar').fullCalendar({
      schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives', 
      titleFormat:"dddd, DD MMMM YYYY",
      defaultView: calendarview,
            nowIndicator: true,
       //     now: this.props.nowdatetime, // just for demo
            eventLimit: true,  
            scrollTime: this.props.currenttime,
            //  eventConstraint: "businessHours",
           // events: this.state.events,
           buttonText: {
               today:    'Today',
            },
           header: {
            left: 'prev,today,next',
            center: 'title',
            right: 'timelineMonth,timelineWeek,timelineCustomWeek,timelineDay'
          },
          views: {
            timelineDay:{buttonText:'Day'},
             timelineWeek:{buttonText: 'Week'},
             agendaDay:{buttonText: 'Route'},
             timelineThreeDays: {
              type: 'timeline',
              duration: { days: 3 }
            }, timelineCustomWeek: {
              type: 'timeline',
              duration: { weeks: 1 },
              slotDuration: {days: 1},
              buttonText: 'Week Collapsed'
           }

            },
          /*  businessHours: {
              start:workingfromtime, // a start time (10am in this example)
              end: workingtotime // an end time (6pm in this example)
            },*/
                editable: false,
                eventClick:function(info){
                   // console.log(info);
                    if(info.title=='Travel Time')return false;
                    if(info.id){
                      localStorage.setItem('eventFcId',info._id);
                      loadpopup(info.id);
                    }
                    
                    //console.log(info);
                },
                resourceAreaWidth:'34%',
                resourceLabelText:'Locations',
                resources:resourcesObject,
                resourceRender: function(resourceObj, th) {
                 // console.log(resourceObj);
                  var currentView = $("#calendar").fullCalendar('getView').name;
                  var image_url='../static/assets/images/location.png';
                 
                  if(typeof resourceObj.image_url != 'undefined'){
                      //image_url=resourceObj.image_url;
                  }

                  if(currentView=='agendaDay'){
                       /*if(th.find("span.fc-cell-text").length == 0){                        
                            th.prepend('<img src="'+image_url+'" height="35px" width="35px" alt="user" style="border-radius:100%;border:2px solid '+resourceObj.eventBackgroundColor+';" class="profile-pic"><br/>');
                       }
                       else{
                            th.find("span.fc-cell-text").prepend('<img src="'+image_url+'" style="border-radius:100%;border:2px solid '+resourceObj.eventBackgroundColor+';" height="35px" width="35px" alt="user" class="profile-pic"> <br/>');
                       }
                        th.css('background',resourceObj.eventBackgroundColor);
                        th.css('color',resourceObj.eventTextColor);
                        th.css('font-weight','600');
                        th.css('font-size','14px');*/
                  }else{
                       if(th.find("span.fc-cell-text").length == 0){                        
                            th.prepend('<img src="'+image_url+'" height="35px" width="35px" alt="user" style="border-radius:100%;border:2px solid '+resourceObj.eventBackgroundColor+';" class="profile-pic"> ');
                       }
                       else{
                            th.find("span.fc-cell-text").prepend('<i className="ti-ruler-pencil"></i><img src="'+image_url+'" style="border-radius:100%;border:0px solid rgba(0,0,0,.125);" height="35px" width="35px" alt="user" class="profile-pic"> ');
                       }
                  }

                       /* if(currentView=='timelineDay'){
                           var currentDate = $('#calendar').fullCalendar('getDate');
                           var fromdate= currentDate.format(DATE_FORAMT);
                          th.find("span.fc-cell-text").append('<button type="button" data-currentDate="'+fromdate+'" data-resourseId="'+resourceObj.id+'" style="float:right;color:'+resourceObj.eventTextColor+';border:1px solid '+resourceObj.eventBackgroundColor+';background:'+resourceObj.eventBackgroundColor+'" class="buildroutes btn waves-effect waves-light btn-rounded btn-sm btn-primary"><i class="fa fa-map-marker"></i></button>');
                        }*/
                  
                  

                 
                  

                

                 
                },
               
                defaultTimedEventDuration:defaultEventDuration,
                events: this.props.schedules,
                eventAllow: function(dropLocation, draggedEvent) {


                 },
                eventRender: function(event, element) {
                   var title = element.find( '.fc-title' );
                   var val=title.text();
                   //console.log(val);
                   
                   title.html(escapeHtml(val)); 
                   if(val =='Travel Time'){
                    var travleTitle='<span style="font-style:italic;">Travel Time</span>';
                    title.html(travleTitle);  
                   }
                   //  alert('eventRender');
                 //  console.log('-----------------eventRender Start-------------------------');
                 //  console.log(info);
                 //  console.log('-----------------eventRender End-------------------------');
                 },
                 droppable: true, 
                 drop: function(date, jsEvent, ui, resourceId) {
                	  console.log("Drop");
                  console.log(this);
                //   alert(this.data('defaultTimedEventDuration'));
               // alert('drop');
              // console.log(jsEvent);
             /*   console.log("scheduleId: "+this.id);
                console.log("dropped");
                console.log(date.format());
                var defaultDuration = moment.duration($('#calendar').fullCalendar('option', 'defaultTimedEventDuration'));
                var end = date.clone().add(defaultDuration); // on drop we only have date given to us
                console.log('end is ' + end.format());
                showpopup($(this));
                //$(this).remove(); */
                document.getElementById("jobscheduleform").reset();
               var start=date.format();
               var defaultDuration = moment.duration($('#calendar').fullCalendar('option', 'defaultTimedEventDuration'));
               var end = date.clone().add(defaultDuration); // on drop we only have date given to us
                
              // localStorage.setItem("eventId",this.id);
                var eventId=this.id;
                console.log(defaultDuration);
                if(start){
                           var fromdate= moment(start).format(DATE_FORAMT);
                           var fromtime= moment(start).format(TIME_FORMAT);
                           $('#fromdate').val(fromdate);
                           $('#fromtime').val(fromtime);
                }

                if(end){
                           var todate= moment(end).format(DATE_FORAMT);
                           var totime= moment(end).format(TIME_FORMAT);
                           $('#todate').val(todate);
                           $('#totime').val(totime);
                }


               let user = JSON.parse(localStorage.getItem(SESSION_USER));
				       getScheduleById(eventId)
				       .then(response => {
				          console.log(response);
				          if(response){
				          	  $('#title').val(response.title);

				          	 if(response.estimatedHours){
				          		//console.log("response.estimatedHours "+response.estimatedHours);
				          		var eventDuration = moment.duration(response.estimatedHours);
				          		eventDuration=eventDuration>0?eventDuration:defaultDuration;
				          		//console.log("estimatedHours "+eventDuration);
					          	  var end = date.clone().add(eventDuration); // on drop we only have date given to us
					          	  if(end){
			                           var todate= moment(end).format(DATE_FORAMT);
			                           var totime= moment(end).format(TIME_FORMAT);
			                           $('#todate').val(todate);
			                           $('#totime').val(totime);
			                       } 
				          	 } 
				          	  
                     // $("input.priority").val(response.priority);


                   if(response.skillList){

                           let skillArray = [];
                           for(var k in response.skillList){
                              var skill=response.skillList[k];
                               skillArray.push({
                                   value: skill.id,
                                   label: skill.name,
                               });
                                
                           }
                          $('#selectedSkill').val(JSON.stringify(skillArray));
                      }

				          	  $('#priority').val(response.priority);
				          	  $('#id').val(response.id);
                      $('#estimatedHours').val(response.estimatedHours);

                      $('#address').val(response.address);
                      $('#description').val(response.description);
                      
                      if(response.equipment){
                         $('#equipment').val(response.equipment.id);
                      }
                   
                      if(response.team){
                          //$('#people').rules('remove');
                          $('#team').val(response.team.id);
                      }
                        /*
                        if(response.location){
                          $('#location').val(response.location.id);
                        }
                        */
                      $('#moduleId').val(response.moduleId);
                      $('#fieldServiceNumber').val(response.fieldServiceNumber);
                      $('#fieldServiceZohoId').val(response.fieldServiceZohoId);
                      $('#zohoAppointmentId').val(response.zohoAppointmentId);
                      
                     
                     if(response.people){
                         // $('#team').rules('remove');
                           let people = {
                               value: response.people.id,
                               label: response.people.firstName+' '+response.people.lastName,
                           };
                           $('#selectedPeoples').val(JSON.stringify(people));
                      }

                      $('#status').val(response.status);

                      /*if(response.fromDate){
                           var fromdate= moment(response.fromDate,APP_DATE_AND_TIME_FORAMT).format(DATE_FORAMT);
                           var fromtime= moment(response.fromDate,APP_DATE_AND_TIME_FORAMT).format(TIME_FORMAT);
                           $('#fromdate').val(fromdate);
                           $('#fromtime').val(fromtime);
                      }

                      if(response.toDate){
                           var todate= moment(response.toDate, APP_DATE_AND_TIME_FORAMT).format(DATE_FORAMT);
                           var totime= moment(response.toDate, APP_DATE_AND_TIME_FORAMT).format(TIME_FORMAT);
                           $('#todate').val(todate);
                           $('#totime').val(totime);
                      }*/

                      $("label.error").hide(); //hide error message jobscheduleform
				          	  showpopup($(this),eventId); //open popup 
				          }

				          
				       }).catch(error => {
                        alert("error in getScheduleById  function");
				       });

             },eventReceive: function (event) {
                      // console.log('-----------------eventReceive Start-------------------------');
                     //  console.log(event);
                       localStorage.setItem('eventFcId',event._id);
                      //  alert(event.resourceId);
                        if(event.resourceId){
                            $('#location').val(event.resourceId);
                           // alert(event.resourceId);
                            
                        }
                     
                       //  event.id = localStorage.getItem("eventId");
                       //  $('#calendar').fullCalendar('updateEvent',event);
                       //  console.log('-----------------eventReceive End-------------------------');
                }
              })

 function escapeHtml(unsafe) {
                if (unsafe == null) {
                    return "";
                  }
                 return unsafe
                      .replace(/&/g, "&amp;")
                      .replace(/</g, "&lt;")
                      .replace(/>/g, "&gt;")
                      .replace(/"/g, "&quot;")
                      .replace(/'/g, "&#039;");
                 }


      function loadpopup(eventId){
          
              let user = JSON.parse(localStorage.getItem(SESSION_USER));
               getScheduleById(eventId)
               .then(response => {
                //  console.log(response);
                  if(response){
                      $('#id').val(response.id);
                      $('#title').val(response.title);
                      $('#priority').val(response.priority);
                      
                      $('#address').val(response.address);
                      $('#description').val(response.description);
                      
                      if(response.equipment){
                         $('#equipment').val(response.equipment.id);
                      }

                        if(response.location){
                         $('#location').val(response.location.id);
                      }

                      if(response.estimatedHours){
  $('#estimatedHours').val(response.estimatedHours);
}

                      if(response.skillList){

                           let skillArray = [];
                           for(var k in response.skillList){
                                 var skill=response.skillList[k];
                                 //console.log('-------ss------------');
                                 //console.log(skill);
                               skillArray.push({
                                   value: skill.id,
                                   label: skill.name,
                               });
                                  //$('#skills').val(skill.id);
                                  // $('#skills').val(skill.id).trigger('change');
                               //$('#skills').select2().val(skill.id).trigger("change")
                           }
                           //console.log('skillArray', skillArray);
                          $('#selectedSkill').val(JSON.stringify(skillArray));
                          // this.setState({selectedSkill: skillArray});
                      }


                   
                      if(response.team){
                        //  $('#people').rules('remove');
                          $('#team').val(response.team.id);
                      }
                       if(response.people){
                         // $('#team').rules('remove');
                          let people = {
                              value: response.people.id,
                              label: response.people.firstName+' '+response.people.lastName,
                          };
                          $('#selectedPeoples').val(JSON.stringify(people));
                      }

                      if(response.fromDate){
                           var fromdate= moment(response.fromDate,APP_DATE_AND_TIME_FORAMT).format(DATE_FORAMT);
                           var fromtime= moment(response.fromDate,APP_DATE_AND_TIME_FORAMT).format(TIME_FORMAT);
                           $('#fromdate').val(fromdate);
                           $('#fromtime').val(fromtime);
                      }

                      if(response.toDate){
                           var todate= moment(response.toDate, APP_DATE_AND_TIME_FORAMT).format(DATE_FORAMT);
                           var totime= moment(response.toDate, APP_DATE_AND_TIME_FORAMT).format(TIME_FORMAT);
                           $('#todate').val(todate);
                           $('#totime').val(totime);
                      }

                      if(response.status){
                        $('#status').val(response.status);
                      }

                      $('#moduleId').val(response.moduleId);
                      if(response.moduleId){
                        $('#moduleId').val(response.moduleId);
                      }
                      
                      
                      $('#fieldServiceNumber').val(response.fieldServiceNumber);
                      $('#fieldServiceZohoId').val(response.fieldServiceZohoId);
                      $('#zohoAppointmentId').val(response.zohoAppointmentId);
                 
                      $("label.error").hide(); //hide error message jobscheduleform
                      showpopup2(eventId); //open popup
                      /*setTimeout(function () {
                          $('#id').val(eventId);
                      },500);*/
                  }

                  
               }).catch(error => {
                        alert("error in getScheduleById  function");
               });
        

      }


                localStorage.removeItem(SSO_PARAMS);
/*-----------------------------------------STOP ON LOAD POPUP CREATOR TO SS (SSO)--------------------------------------------------------*/
                
                  $('#date-daily').change(function () {
                     var selectedDate = $('#date-daily').val();
                    var view= $('#calendar').fullCalendar('getView');
                   // alert("The view's title is " + view.name);

                     $('#calendar').fullCalendar('changeView',view.name);
                     selectedDate = moment(selectedDate, "MM/DD/YYYY").format("MM/DD/YYYY"); 
                     $('#calendar').fullCalendar('gotoDate', selectedDate );
             
                });


          if(this.props.calendarview=='agendaDay'){
              $('.fc-right').css('display','none'); 
          }

                


   
}

 updateCalendarEvents(){
    let user = JSON.parse(localStorage.getItem(SESSION_USER));
    getAllScheduleEvent(user.id).then(response => {
                        //console.log(response);
                       if(response.schedules){ 
                             $('#calendar').fullCalendar('removeEvents');
                            
                                      $('#calendar').fullCalendar('addEventSource',response.schedules);

                        }     
                      
                }).catch(error => {
                   if(error.status === 404) {
                        this.setState({
                            notFound: true,
                        });
                    } else {
                        this.setState({
                            serverError: true,
                        });        
                    }
                });


        
         
       
 }

  handlePeopleChange(){
       window.location.href='/schedule';

  
  }
   handleJobChange(){
     window.location.href='/jobschedule';
   }

   handleEquipmentChange(){
       window.location.href='/equipmentview';
   }

    handleLocationChange(){
       window.location.href='/locationview';
   }
   
   handleTeamChange(){
       window.location.href='/teamview';
   }



  handleRouteChange(){
     window.location.href='/schedule?view=agendaDay';
  }


    render() {

         const travelEventBgColor=this.props.travelEventBgColor;
         const travelEventStyle = {
                color:travelEventBgColor
          }

          var className='';
          if(this.props.calendarview=='agendaDay'){

          }


        return <div className="col-md-9">

            <div className="card">
                <div className="card-body">
                 <div className="row1">
                 
                  <div style={{float:'left'}}>
                   
                     <div className="view-by-items-block">
                           <span style={{cursor:'pointer',display:'none'}} onClick={this.handleJobChange} className="view-by-item">
                             <i className="icon-list "></i><button style={{display:'none1'}} type="button" id="jobview" onClick={this.handleJobChange} className=" btn waves-effect waves-light btn-outline-success btn-rounded btn-xs">Job</button>
                            </span>

                            <span style={{cursor:'pointer'}} onClick={this.handlePeopleChange} className="view-by-item"  >
                             <i className="icon-user  "></i><button type="button" id="peopleview" onClick={this.handlePeopleChange} className={this.props.calendarview=='agendaDay' ? 'btn waves-effect waves-light btn-outline-success btn-rounded btn-xs':' btn waves-effect waves-light btn-outline-success btn-rounded btn-xs'}>Employee</button>
                           </span>

                           <span style={{cursor:'pointer'}} onClick={this.handleRouteChange} className="view-by-item" style={{display:'none'}}>
                             <i className="icon-user  "></i><button type="button" id="routeview" onClick={this.handleRouteChange} className={this.props.calendarview=='agendaDay' ? 'active btn waves-effect waves-light btn-outline-success btn-rounded btn-xs':'btn waves-effect waves-light btn-outline-success btn-rounded btn-xs'}>Route</button>
                           </span>

                           <span style={{cursor:'pointer'}} onClick={this.handleEquipmentChange} className="view-by-item">
                            <i className="icon-settings"></i><button type="button" id="equipmentview" onClick={this.handleEquipmentChange} className="btn waves-effect waves-light btn-outline-success btn-rounded btn-xs">Equipment</button>
                           </span>

                           <span style={{cursor:'pointer'}} onClick={this.handleTeamChange} className="view-by-item">
                             <i className="icon-people"></i><button type="button" id="teamview" onClick={this.handleTeamChange} className="btn waves-effect waves-light btn-outline-success btn-rounded btn-xs">Crew</button>
                         </span>

                         <span style={{cursor:'pointer'}} onClick={this.handleLocationChange} className="view-by-item">
                              <i className="icon-location-pin active"></i><button type="button" id="locationview" onClick={this.handleLocationChange} className="active  btn waves-effect waves-light btn-outline-success btn-rounded btn-xs">Location</button>
                        </span>
                    </div>
                  </div>

                  


                                        

                          <div style={{float:'right'}}>&nbsp;&nbsp;&nbsp;&nbsp; <input type="text" id="date-daily" placeholder="Select the date"  style={{width:'115px',position:'relative',zIndex: '10',height:'24px',border:'1px solid grey',color:'#333',borderRadius:'3px'}} /></div> &nbsp;&nbsp;
                    

                   <div style={{float:'right',fontSize:'13px'}}><i className="fa fa-circle" style={{color:'rgb(196, 194, 193)'}}></i>  Off Hours  </div> &nbsp;&nbsp;
                   <div style={{float:'right',fontSize:'13px'}}><i className="fa fa-circle" style={travelEventStyle}></i>  Travel Time   &nbsp;&nbsp;</div>
                  
               
                 </div>
 
                  <div id="calendar" style={{clear:'both'}}></div>
                
                          
                 <JobScheduleForm fields={this.props.fields} states={this.state}/>

                
                 <GoogleMapForm  updateCalendarEvents={this.updateCalendarEvents}/>
                </div>
            </div>
        </div>;
    }
}

export default LocationCalendar;